// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3_Sq3","label":"Completed_label__2kzEK"};